import { RouteRecordRaw } from 'vue-router'

const CatalogPage = () =>
  import(
    /* webpackChunkName: "master-data-catalog" */ './pages/CatalogPage.vue'
  )

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'datos-maestros/:slug',
    name: 'master-data-catalog',
    component: CatalogPage,
    meta: {
      title: 'Datos maestros',
      auth: {
        requiredPermission: 'catalogs.view',
        requiredModule: 'catalogs',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
